import { Modal, Button } from "antd";
import styled from "styled-components";
import DatatableAntd from "components/datatable-antd";
import columns from "./columns";
import useGetOperacoesByClasseId from "../../hooks/useGetOperacoesByClasseId";
import useModal from "../../hooks/useModal";

function OperacoesModal() {

  const { id, isOperacoesOpen, classe, setIsOperacoesOpen, setId } = useModal();
  const { data, isLoading } = useGetOperacoesByClasseId(id);

  function handleClose() {
    setId(null);
    setIsOperacoesOpen(false);
  }

  return (
    <CustomModal
      title={
        <Header>
          Operações da Classe: {classe}
        </Header>
      }
      visible={isOperacoesOpen}
      onCancel={handleClose}
      width={700}
      maskClosable={false}
      footer={
        <Button
          size="large"
          type="primary"
          loading={isLoading}
          onClick={handleClose}
          style={{ borderRadius: 8, backgroundColor: "#12619C" }}
        >Fechar</Button>
      }
    >
      <h2 style={{ marginBottom: 16, fontSize: 16 }}>
        Total de Operacões Vinculadas: <b>{data?.length}</b>
      </h2>
      <DatatableAntd
        loading={isLoading}
        dataSource={data?.sort((a, b) => a.codigo - b.codigo)}
        columns={columns}
        maxH="443"
        overflow="auto"
      />
    </CustomModal>
  );
}

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CustomModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 10px;
  }

  .ant-modal-header {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #12619C;
  }

  .ant-modal-title {
    color: #fff;
    font-weight: bold;
  }

  .ant-modal-close-x {
    color: #fff;
  }
`;

export default OperacoesModal;
